<div class="d-flex justify-content-center flex-column pt-5">
  <div class="text-center">
    <h1>Шаги самодиагностики</h1>
    <p class="mt-0 mb-4 font-size-16 color-grey-desc">Содержит список служб и сервисов по которым могут быть созданы заявки.</p>
  </div>
  <div class="search-service">
    <div>
      <dx-select-box
        [dataSource]="searchDataSource"
        [(value)]="this.serviceId"
        displayExpr="name"
        valueExpr="id"
        placeholder="{{ 'SEARCH_IT_SERVICE' | translate }}"
        [minSearchLength]="2"
        [searchEnabled]="true"
        [searchTimeout]="500"
        (onSelectionChanged)="this.selectService($event)"
        class="search-dx-select-box mdi mdi-magnify">
        <div *dxTemplate="let data of 'item'" class="custom-item">
          <div>{{ data.name }}</div>
          <div class="category color-black" style="font-size: 80%; color: #091e42">
            {{ data.category }}
          </div>
        </div>
      </dx-select-box>
    </div>
    <div>
      @if (this.serviceId && !this.selectMenuItem) {
        <dx-button
          text="{{ 'NEXT' | translate }}"
          (onClick)="this.goToSelfDiagnosticSteps(this.serviceId)"
          class="btn mb-2 ms-0 ms-md-2"
          icon="mdi mdi-chevron-right"></dx-button>
      }
      @if (this.serviceId && this.selectMenuItem) {
        <dx-button
          text="{{ 'CREATE_ORDER' | translate }}"
          (onClick)="this.createOrder()"
          class="btn mb-2 ms-0 ms-md-2"
          icon="mdi mdi-chevron-right"></dx-button>
      }
      <dx-button
        text="{{ 'SWITCH_TO_CATALOG' | translate }}"
        (onClick)="this.goToCatalog()"
        class="btn btn-light mb-2 ms-0 ms-md-2"
        icon="mdi mdi-format-list-bulleted-square"></dx-button>
    </div>
  </div>
</div>
